import { render, staticRenderFns } from "./Toolbox.vue?vue&type=template&id=13bea138&scoped=true&"
import script from "./Toolbox.vue?vue&type=script&lang=js&"
export * from "./Toolbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bea138",
  null
  
)

export default component.exports